import Wallet from "../../assets/images/wallet_instant.png";
import { Footer, Navbar } from "./landingpage";

const features = [
  {
    title: "Deposit easily via bank transfer"
  },
  {
    title: "Instant withdrawals to any Nigerian bank"
  },
  {
    title: "Secure Wallet with biometrics & PIN lock"
  }
]

const JamestownWallet = () => {
  return (
    <div>
      <div className="sm:px-20 px-3">
      <Navbar />
      </div>
      <div className="flex justify-between sm:px-20 px-3">
        <div className="w-[50%]">
          <h3 className="text-5xl font-bold">Your Smart All-in-One Digital Wallet</h3>
          <p className="mt-5 p-1 font-Manrope text-lg">
            The Jamestown Wallet is designed to help you manage your finances
            with ease. With just one wallet, you can store money, transfer
            funds, pay bills, buy airtime, manage assets and track every
            transaction.
          </p>
        </div>

        <div className="w-[40%]">
          <img src={Wallet} alt="Wallet" className="rounded-lg" />
        </div>
      </div>

      <div className="sm:px-20 px-3">
        {features.map((feature => (
          <div key={feature.title}>
            <h2>{feature.title}</h2>
          </div>
        )))}
      </div>

      <Footer />
    </div>
  );
};

export default JamestownWallet;
